import type { IconProps } from './types';

export const ItalicIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18.3567 0.535714L18.4338 0.53962C18.812 0.57805 19.1067 0.897406 19.1067 1.28571C19.1067 1.67402 18.812 1.99338 18.4338 2.03181L18.3567 2.03571H14.3206L7.35571 15.9644H11.2854L11.3625 15.9683C11.7406 16.0068 12.0354 16.3262 12.0354 16.7144C12.0353 17.1026 11.7406 17.422 11.3625 17.4605L11.2854 17.4644H1.64282C1.22865 17.4644 0.892897 17.1286 0.892822 16.7144C0.892822 16.3002 1.22861 15.9644 1.64282 15.9644H5.67896L12.6438 2.03571H8.71411C8.29996 2.03564 7.96411 1.69988 7.96411 1.28571C7.96411 0.871547 8.29996 0.53579 8.71411 0.535714H18.3567Z"
        fill={color}
      />
    </svg>
  );
};
